var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-progress-linear',{staticClass:"absolute",staticStyle:{"z-index":"9999"},attrs:{"indeterminate":_vm.loading,"height":5,"color":"primary"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }